import styled from 'styled-components';
import * as color from '../styleVariables';

const Input = styled.input`
padding: 10px;
border-radius: 10px;
border: 1px solid ${color.seventhColor};
margin: 10px 0;
`;

export default Input;
